import { LOCATION_CHANGE } from 'connected-react-router';
import { Reducer } from 'redux';
import { UIAction, EXPAND_PHASE_PLAN_MENU, SET_SELECT_PRESSED, KEY_UP_EVENT, KEY_DOWN_EVENT, COLUMN_SELECTED, KEY_CLEARED, TOGGLE_HISTOGRAM, COLUMN_CLEAR, CLEAR_PENDING_DRAG_UPDATES, SHOW_PENDING_DRAG_UPDATES, UPDATE_ZOOM } from '../actions/ui.actions';
import { ColumnType } from '../components/PhasePlan/Column';


export type Point = {
    column: number,
    row: number
}

export interface UIState {
    readonly isPhasePlanMenuExpanded: boolean;
    readonly isSelectMultiPressed: boolean;
    readonly keysPressed: string[],
    readonly phasePlanColumnSelected: Point | null,
    readonly lookaheadColumnSelected: Point | null,
    readonly lastKeyTime: number | null,
    readonly openHistogram: boolean,
    readonly draggedNewPoint: Point | null,
    readonly draggedOldPoint: Point | null,
    readonly draggedId: string | null,
    readonly selectedNewPoints: Array<Point> | null,
    readonly zoom: number

}


const defaultState: UIState = {
    isPhasePlanMenuExpanded: true,
    isSelectMultiPressed: false,
    keysPressed: [],
    phasePlanColumnSelected: null,
    lookaheadColumnSelected: null,
    lastKeyTime: null,
    openHistogram: false,
    draggedId: null,
    draggedNewPoint: null,
    draggedOldPoint: null,
    selectedNewPoints: null,
    zoom: 100

};

export const uiReducer: Reducer<UIState> = (
	state = defaultState,
	action: UIAction | any
) => {
    switch (action.type) {
        case EXPAND_PHASE_PLAN_MENU:
            return {
                ...state,
                isPhasePlanMenuExpanded: !state.isPhasePlanMenuExpanded
            };
        case SET_SELECT_PRESSED:
            if(state.isSelectMultiPressed == action.payload.isSelected) {
                return state
            }
            return {
                ...state,
                isSelectMultiPressed: action.payload.isSelected
            }
        case KEY_UP_EVENT:

            const upkeys = new Set<string>(state.keysPressed)
            upkeys.delete(action.payload.key)
            
            return {
                ...state,
                keysPressed: [...upkeys]
            }
        case KEY_DOWN_EVENT:
            const downkeys = new Set<string>(state.keysPressed)
            downkeys.add(action.payload.key)

            return {
                ...state,
                keysPressed: [...downkeys],
                lastKeyTime: action.payload.lastKeyTime
            }
        case KEY_CLEARED:
            return {
                ...state,
                keysPressed: []
            }
        case COLUMN_SELECTED:
            const type = action.payload.type
            const column = action.payload.column
            const row = action.payload.row

            if(type === ColumnType.PhasePlan) {
                return {
                    ...state,
                    phasePlanColumnSelected: {
                        column,
                        row
                    }
                }
            }

            if(type === ColumnType.Lookahead) {
                return {
                    ...state,
                    lookaheadColumnSelected: {
                        column,
                        row
                    }
                }
            }


            return state
        case COLUMN_CLEAR:
            return {
                ...state,
                phasePlanColumnSelected: null,
                lookaheadColumnSelected: null
            }
        case TOGGLE_HISTOGRAM:
            return {
                ...state,
                openHistogram: !state.openHistogram
            }
        case CLEAR_PENDING_DRAG_UPDATES:
            return {
                ...state,
                draggedId: null,
                draggedOldPoint: null,
                draggedNewPoint: null,
                selectedNewPoints: null,
            }
        case SHOW_PENDING_DRAG_UPDATES:
            return {
                ...state,
                draggedId: action.payload.draggedId,
                draggedOldPoint: action.payload.draggedOldPoint,
                draggedNewPoint: action.payload.draggedNewPoint,
                selectedNewPoints: action.payload.selectedNewPoints,
            }
        case UPDATE_ZOOM:
            return {
                ...state,
                zoom: action.payload.zoom
            }
        case LOCATION_CHANGE: 
            return {
                ...state,
                zoom: 100
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/modules/ui.reducer.ts